var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoNavtrac = function SvgLogoNavtrac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 195 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_navtrac_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.95 5.67h5.65l8.54 13.6V5.67h5.15v22.67h-5.25l-8.91-14.25v14.25h-5.19V5.67h.01ZM75.69 5.67h5.22l8.38 22.67h-5.5l-1.18-3.38h-8.66l-1.18 3.38h-5.46l8.38-22.67Zm-.06 14.56h5.34l-2.67-7.61-2.67 7.61ZM86.15 5.67h5.65l5.34 15.31 5.37-15.31h5.62l-8.38 22.67h-5.22L86.15 5.67ZM115.93 10.67h-6.15v-5h17.51v5h-6.09v17.67h-5.28V10.67h.01ZM130.36 5.67h9.75c5.46 0 8.51 3.51 8.51 7.79 0 2.89-1.4 5.34-3.66 6.68l4.22 8.2h-5.96l-3.2-6.8h-4.25v6.8h-5.4V5.67h-.01Zm5.41 4.94v6.02h3.94c2.3 0 3.38-1.37 3.38-3.04 0-1.86-1.12-2.98-3.38-2.98h-3.94ZM158.46 5.67h5.22l8.38 22.67h-5.5l-1.18-3.38h-8.66l-1.18 3.38h-5.46l8.38-22.67Zm-.06 14.56h5.34l-2.67-7.61-2.67 7.61ZM172.03 17c0-6.61 4.94-11.64 11.61-11.64 4.38 0 8.07 2.24 10.09 5.59l-4.75 3.01c-1.02-2.02-2.83-3.29-5.31-3.29-3.6 0-6.12 2.83-6.12 6.33s2.45 6.27 6.06 6.27c2.7 0 4.56-1.55 5.5-3.7l5 2.67c-1.92 3.76-5.62 6.4-10.46 6.4-6.99 0-11.61-5.19-11.61-11.64h-.01Z",
    fill: "#333D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.19 11.34h-8.97V0h19.82c.53 0 .97.43.97.95v19.83H22.67v-8.97c0-.26-.22-.48-.48-.48v.01ZM11.82 22.68c-.27 0-.48-.21-.48-.48V0L.28 10.93a.96.96 0 0 0-.28.68v21.46c0 .53.43.95.97.95h21.31c.27 0 .51-.11.68-.28l11.06-11.06h-22.2Z",
    fill: "url(#logo_navtrac_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_navtrac_svg__b",
    x1: 0.25,
    y1: 33.7,
    x2: 33.7,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84F11E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_navtrac_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h194.11v34.02H0z"
  })))));
};

export default SvgLogoNavtrac;